<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Besigtigelse" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<select-view label="Afdeling" v-model="entity.department_id" :options="departments" optionValueName="id" />
					<employee-select-view v-model="entity" label="Ansvarlig" :optional="true" />
				</div>
				<div v-show="active == 'details'">
					<contact-select-view v-model="entity" label="Kunde" :optional="true" @select="contactSelect" />
				</div>
				<div v-show="active == 'details'">
					<string-view v-model="entity.name" label="Navn" />
					<string-view v-model="entity.phone" label="Telefon" :optional="true" />
					<string-view v-model="entity.email" label="E-mail" :optional="true" />
				</div>
				<div v-show="active == 'details'">
					<date-select-view label="Dato" v-model="entity.due_start" :controller="$store.state.popupController" :suggestions="suggestions" />
					<form-line-layout>
						<clock-select-view label="Ankomst mellem" v-model="entity.from" :controller="$store.state.popupController" />
						<clock-select-view v-model="entity.to" :controller="$store.state.popupController" />
					</form-line-layout>
					<clock-select-view label="Varighed" v-model="entity.details.duration" :controller="$store.state.popupController" />
					<div class="side-window__heading">
						Send SMS påmindelse dagen før
						<switch-view v-model="entity.reminder" />
					</div>
				</div>
				<div v-show="active == 'details'">
					<string-view v-model="entity.hour_rate" label="Timepris" />
				</div>
				<div v-show="active == 'details'">
					<date-select-view label="Flyttedato" v-model="entity.details.date" :controller="$store.state.popupController" />
					<text-view label="Bemærkninger" :height="200" :optional="true" v-model="entity.remarks" />
				</div>
				<address-view v-show="active == 'address'" v-model="entity.details.address" :contact_id="entity.contact_id" />
				<div v-show="active == 'address'">
					<string-view label="Areal" :optional="true" v-model="entity.details.area" />
				</div>
				<address-view v-show="active == 'dest'" v-model="entity.details.dest" :contact_id="entity.contact_id" />
				<div v-show="active == 'files'">
					<file-list-view v-model="entity.details.files" />
				</div>
				<div v-show="active == 'requirements'">
					<requirements-view v-model="entity.requirements" />
				</div>
				<div v-show="active == 'photos'">
					<photos-view v-model="entity.details.photos" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Gem" @click="onAddButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import SurveyTaskModel from '../model/SurveyTask'

	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';
	import RouteView from '../views/RouteView';
	import RequirementsView from '../views/RequirementsView';
	import PhotosView from '../views/PhotosView';
	import InstructionsView from '../views/InstructionsView';
	import PackagingView from '../views/PackagingView';
	import OrderView from '../views/OrderView';
	import EmployeeSelectView from '../views/EmployeeSelectView';
	import ContactSelectView from '../views/ContactSelectView';
	import AddressView from '../views/AddressView';

	import merge from '../functions/merge'
 
	const stop = {

	};

	export default {
		data: function () {
			return {
				entity: {},
				packaging: [],
				ORDER: [],
				active: 'details',
				instructions: [],
				departments: [],
				suggestions: [],
				types: []
			};
		},
		watch: {
			'entity.from': function (n) {
				if (n > this.entity.to) {
					this.entity.to = n;
				}
			},
			'entity.to': function (n) {
				if (n < this.entity.from) {
					this.entity.from = n;
				}
			},
			'entity.due_from': function (n) {
				this.entity.end = n;
			},
			'entity.contact_id': function (n) {
				if (n) {
					var self = this;

					this.axios
						.get('/contacts/' + n + '/tasks/latest/')
						.then(function (r) {
							self.suggestions = r.data._items.map(function (item) {
								return {
									date: 	(new Date(item.due_start_from)).format('Y-m-d'),
									label: 	self._types.hasOwnProperty(item.type) ? self._types[item.type].label : ''
								};
							});
							//self.departments = r.data._items;

							
						});
				} else {
					this.suggestions = [];
				}
			}
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView,
			'RouteView': RouteView,
			'RequirementsView': RequirementsView,
			'PhotosView': PhotosView,
			'InstructionsView': InstructionsView,
			'PackagingView': PackagingView,
			'OrderView': OrderView,
			'EmployeeSelectView': EmployeeSelectView,
			'AddressView': AddressView,
			'ContactSelectView': ContactSelectView
		},
		computed: {
			_types() {
				var r = {};

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = this.types[i];
				}

				return r;
			},
			_roles() {
				var r = {};
				var role;
				var props;
				var prop;

				for (var i = 0; i < this.roles.length; ++i) {
					role = this.roles[i];
					props = {};
					
					for (var j = 0; j < role.props.length; ++j) {
						prop = role.props[j];
						props[prop.name] = prop.default;
					}

					r[role.name] = {
						enabled: false,
						props: props
					};
				}

				return r;
			},
			tabs: function () {
				return [
					{
						name: 'details',
						label: 'Detaljer'
					},
					{
						name: 'address',
						label: 'Fra'
					},
					{
						name: 'dest',
						label: 'Til'
					},
					{
						name: 'requirements',
						label: 'Behov'
					},
					{
						name: 'files',
						label: 'Filer'
					},
					{
						name: 'photos',
						label: 'Fotos'
					}
				];
			}
		},
		props: {
			id: Number,
			form: Boolean,
			submit: {
				type: Function,
				default: function () {}
			},
			value: {
				type: Object,
				default() {
					return merge({}, SurveyTaskModel);
				}
			}
		},
		methods: {
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			onAddButtonClick() {
				
				this.submit(this.entity);
			},
			contactSelect(obj) {
				

				this.entity.name = obj.name;
				this.entity.email = obj.email;
				this.entity.phone = obj.phone;

				// Also on route
				if (!this.entity.id) {
					this.entity.details.address.address 	= obj.address;
					this.entity.details.address.zip 		= obj.zip;
					this.entity.details.address.city 		= obj.city;
					this.entity.details.address.country 	= obj.country;
				}
			}
		},
		mounted: function() {
			
			

			var self = this;

			this.entity = merge({}, this.value);

			

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/tasks/types/')
				.then(function (r) {
					self.types = r.data._items;
					//self.departments = r.data._items;
				});

			/*this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.entity.roles = {...self._roles, ...self.entity.roles};
				});*/

		}
	}
</script>

<style lang="scss">
	
</style>
